import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { vehicles } from '../data/vehicles';
import { ChevronLeft, ChevronRight, MessageCircle, Calendar, Gauge, Fuel, Settings, Palette, Car, CheckCircle2, Share2, Heart } from 'lucide-react';
export function VehicleDetail() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const vehicle = vehicles.find(v => v.id === Number(id));
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  if (!vehicle) {
    return <div className="min-h-[60vh] flex flex-col items-center justify-center" data-id="element-290" data-mp="30ju5lun2w9lw">
        <h2 className="text-2xl font-bold text-[#F2F0E9] mb-4" data-id="element-291" data-mp="2luxwrvd76sk8">
          Vehículo no encontrado
        </h2>
        <button onClick={() => navigate('/')} className="px-6 py-2 bg-[#C9A24E] text-[#1A1C17] font-semibold rounded-lg hover:bg-[#E3BE72] transition-colors" data-id="element-292" data-mp="2qq4ywyqtjp71">
          Volver al catálogo
        </button>
      </div>;
  }
  const nextImage = () => {
    setCurrentImageIndex(prev => prev === vehicle.gallery.length - 1 ? 0 : prev + 1);
  };
  const prevImage = () => {
    setCurrentImageIndex(prev => prev === 0 ? vehicle.gallery.length - 1 : prev - 1);
  };
  const handleWhatsApp = () => {
    const message = `Hola Lusso Group, estoy interesado en el ${vehicle.year} ${vehicle.make} ${vehicle.model} ${vehicle.trim} publicado a ${vehicle.price}.`;
    window.open(`https://wa.me/541139465079?text=${encodeURIComponent(message)}`, '_blank');
  };
  return <div className="max-w-[1200px] mx-auto px-4 py-8" data-id="element-293" data-mp="2cezw1m6qnt6j">
      {/* Breadcrumb & Actions */}
      <div className="flex items-center justify-between mb-6" data-id="element-294" data-mp="27ot6nk4ek4n8">
        <button onClick={() => navigate('/')} className="flex items-center text-[#C6C4B9] hover:text-[#C9A24E] transition-colors font-medium" data-id="element-295" data-mp="27n8cvwpwwpqf">
          <ChevronLeft className="w-5 h-5 mr-1" data-id="element-296" data-mp="1ez2ql5j7msoh" />
          Volver
        </button>
        <div className="flex items-center gap-3" data-id="element-297" data-mp="3f2wuqhojsc4r">
          <button aria-label="Compartir" className="p-2 rounded-full bg-[#2B2E27] border-2 border-[#C9A24E] text-[#F2F0E9] hover:border-[#E3BE72] transition-colors shadow-sm" data-id="element-298" data-mp="3f00x6ugm3pgu">
            <Share2 className="w-5 h-5" data-id="element-299" data-mp="3ouasol0up3vs" />
          </button>
          <button aria-label="Guardar" className="p-2 rounded-full bg-[#2B2E27] border-2 border-[#C9A24E] text-[#F2F0E9] hover:border-[#E3BE72] transition-colors shadow-sm" data-id="element-300" data-mp="3st0cavchfhnv">
            <Heart className="w-5 h-5" data-id="element-301" data-mp="312m4ngv2b1kn" />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-302" data-mp="35362ynrdgb8d">
        {/* Left Column: Gallery & Description */}
        <div className="lg:col-span-2 space-y-8" data-id="element-303" data-mp="3a4bvakh4dwhd">
          {/* Main Gallery */}
          <div className="bg-[#2B2E27] rounded-2xl overflow-hidden shadow-sm border-2 border-[#C9A24E]" data-id="element-304" data-mp="kcx5ert71x0l">
            <div className="relative aspect-[16/9] bg-[#1A1C17] group" data-id="element-305" data-mp="pb8dawzxhxg6">
              <img src={vehicle.gallery[currentImageIndex]} alt={`${vehicle.make} ${vehicle.model}`} className="w-full h-full object-contain" data-id="element-306" data-mp="zgzxpseogqc5" />

              {/* Gallery Controls */}
              <button onClick={prevImage} aria-label="Foto anterior" className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-[#F2F0E9]/90 backdrop-blur-sm flex items-center justify-center text-[#1A1C17] hover:bg-[#C9A24E] transition-opacity duration-200 opacity-0 group-hover:opacity-100 shadow-md" data-id="element-307" data-mp="pou64jsc8axh">
                <ChevronLeft className="w-6 h-6" data-id="element-308" data-mp="6skrnvdixicy" />
              </button>
              <button onClick={nextImage} aria-label="Foto siguiente" className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-[#F2F0E9]/90 backdrop-blur-sm flex items-center justify-center text-[#1A1C17] hover:bg-[#C9A24E] transition-opacity duration-200 opacity-0 group-hover:opacity-100 shadow-md" data-id="element-309" data-mp="2riurl72xie5">
                <ChevronRight className="w-6 h-6" data-id="element-310" data-mp="2971j4xsp8i14" />
              </button>

              {/* Image Counter */}
              <div className="absolute bottom-4 right-4 px-3 py-1 rounded-full bg-[#1A1C17]/80 backdrop-blur-sm text-[#F2F0E9] text-sm font-medium" data-id="element-311" data-mp="1v5ywojxsl5po">
                {currentImageIndex + 1} / {vehicle.gallery.length}
              </div>
            </div>

            {/* Thumbnails */}
            <div className="flex gap-2 p-4 overflow-x-auto" data-id="element-312" data-mp="1q874dot8jhky">
              {vehicle.gallery.map((img, idx) => <button key={idx} onClick={() => setCurrentImageIndex(idx)} className={`relative flex-shrink-0 w-24 aspect-[4/3] rounded-lg overflow-hidden border-2 transition-colors duration-200 ${currentImageIndex === idx ? 'border-[#C9A24E]' : 'border-transparent hover:border-[#C9A24E]/50'}`} data-id="element-313" data-mp="1bk2ikbyvypxy" data-mpi={idx}>
                  <img src={img} alt={`Foto ${idx + 1}`} className="w-full h-full object-cover" data-id="element-314" data-mp="nve1ngppj6o3" />
                </button>)}
            </div>
          </div>

          {/* Description */}
          <div className="bg-[#2B2E27] rounded-2xl p-6 shadow-sm border-2 border-[#C9A24E]" data-id="element-315" data-mp="wtzkze306ppx">
            <h3 className="text-xl font-bold text-[#F2F0E9] mb-4" data-id="element-316" data-mp="sx3hrarseaj1">
              Descripción del Vehículo
            </h3>
            <p className="text-[#C6C4B9] leading-relaxed whitespace-pre-line" data-id="element-317" data-mp="11votalyucpab">
              {vehicle.description}
            </p>
          </div>

          {/* Equipment */}
          <div className="bg-[#2B2E27] rounded-2xl p-6 shadow-sm border-2 border-[#C9A24E]" data-id="element-318" data-mp="1gm4iscyaijea">
            <h3 className="text-xl font-bold text-[#F2F0E9] mb-4" data-id="element-319" data-mp="1bnbdh7t5pyp7">
              Equipamiento Destacado
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-320" data-mp="1klwrcpnoopjn">
              {vehicle.equipment.map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-321" data-mp="i9a2ws703eng" data-mpi={idx}>
                  <CheckCircle2 className="w-5 h-5 text-[#C9A24E] flex-shrink-0 mt-0.5" data-id="element-322" data-mp="n7ld5417jr67" />
                  <span className="text-[#C6C4B9]" data-id="element-323" data-mp="n57hasypeaxl">{item}</span>
                </div>)}
            </div>
          </div>
        </div>

        {/* Right Column: Info & CTAs */}
        <div className="space-y-6" data-id="element-324" data-mp="w2025ybjig2i">
          {/* Price & Basic Info Card */}
          <div className="bg-[#2B2E27] rounded-2xl p-6 shadow-sm border-2 border-[#C9A24E] sticky top-6" data-id="element-325" data-mp="10ygn6jng0ebd">
            <div className="mb-6" data-id="element-326" data-mp="15w8g9gztq6h5">
              <h1 className="text-3xl font-bold text-[#F2F0E9] mb-2 leading-tight" data-id="element-327" data-mp="1axfn9du571mr">
                {vehicle.year} {vehicle.make} {vehicle.model}
              </h1>
              <p className="text-lg text-[#A8AA9E] mb-4" data-id="element-328" data-mp="1exyfva3v0bq0">{vehicle.trim}</p>
              <div className="flex items-center gap-3 flex-wrap" data-id="element-329" data-mp="3cpue52enzgfb">
                <span className={`text-4xl font-bold ${vehicle.sold ? 'text-[#8C8F84]' : 'text-[#C9A24E]'}`} data-id="element-330" data-mp="3gpl0mtx5rae1">
                  {vehicle.price}
                </span>
                {vehicle.sold && <span className="px-3 py-1 rounded-full bg-[#1A1C17]/80 border border-[#C9A24E]/60 text-[11px] font-medium tracking-[0.18em] text-[#C9A24E]" data-id="element-331" data-mp="34ebwrnrcpazs">
                    VENDIDO
                  </span>}
              </div>
            </div>

            {/* Quick Specs Grid */}
            <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-332" data-mp="3s4xtwjzthav0">
              <div className="flex items-center gap-3 p-3 rounded-xl bg-[#343830]" data-id="element-333" data-mp="3n5v0jwt78t2v">
                <Calendar className="w-5 h-5 text-[#A8AA9E]" data-id="element-334" data-mp="3j4j5vcvgxhnt" />
                <div data-id="element-335" data-mp="3j2ychqkw44rj">
                  <p className="text-xs text-[#A8AA9E]" data-id="element-336" data-mp="3j6m2wgv1gb21">Año</p>
                  <p className="font-semibold text-[#F2F0E9]" data-id="element-337" data-mp="3e56jet8ieclr">{vehicle.year}</p>
                </div>
              </div>
              <div className="flex items-center gap-3 p-3 rounded-xl bg-[#343830]" data-id="element-338" data-mp="27njgap0i9gxh">
                <Gauge className="w-5 h-5 text-[#A8AA9E]" data-id="element-339" data-mp="22p84w9ukayd5" />
                <div data-id="element-340" data-mp="6n52k2laz53u">
                  <p className="text-xs text-[#A8AA9E]" data-id="element-341" data-mp="6mll0mzkeiqc">Kilometraje</p>
                  <p className="font-semibold text-[#F2F0E9]" data-id="element-342" data-mp="aphxdvyihilu">
                    {vehicle.mileage}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3 p-3 rounded-xl bg-[#343830]" data-id="element-343" data-mp="3swxvqpzorrem">
                <Settings className="w-5 h-5 text-[#A8AA9E]" data-id="element-344" data-mp="1ok15zubefdt" />
                <div data-id="element-345" data-mp="pexk90ux93w9">
                  <p className="text-xs text-[#A8AA9E]" data-id="element-346" data-mp="peec2bv2ptvf">Transmisión</p>
                  <p className="font-semibold text-[#F2F0E9] text-sm" data-id="element-347" data-mp="ud8uvdt1jifj">
                    {vehicle.transmission}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-3 p-3 rounded-xl bg-[#343830]" data-id="element-348" data-mp="kmwdfugiw5dm">
                <Fuel className="w-5 h-5 text-[#A8AA9E]" data-id="element-349" data-mp="18cqnk49gjfu6" />
                <div data-id="element-350" data-mp="18b5smdj8duvs">
                  <p className="text-xs text-[#A8AA9E]" data-id="element-351" data-mp="18anoyvu8oedu">Combustible</p>
                  <p className="font-semibold text-[#F2F0E9]" data-id="element-352" data-mp="1d48o4r7kjeem">{vehicle.fuel}</p>
                </div>
              </div>
            </div>

            {/* Detailed Specs List */}
            <div className="space-y-4 mb-8 border-t border-[#C9A24E]/40 pt-6" data-id="element-353" data-mp="2svkn394yfm7s">
              <div className="flex justify-between items-center" data-id="element-354" data-mp="36lxvtdpo74y6">
                <span className="text-[#A8AA9E] flex items-center gap-2" data-id="element-355" data-mp="36oaa9gw7yx6h">
                  <Car className="w-4 h-4" data-id="element-356" data-mp="32l48omk1xu6c" /> Motor
                </span>
                <span className="font-medium text-[#F2F0E9] text-right" data-id="element-357" data-mp="2eu8a96l3c0q4">
                  {vehicle.engine}
                </span>
              </div>
              <div className="flex justify-between items-center" data-id="element-358" data-mp="29y00y9tkr1qv">
                <span className="text-[#A8AA9E] flex items-center gap-2" data-id="element-359" data-mp="2nwhjlt4mho1x">
                  <Palette className="w-4 h-4" data-id="element-360" data-mp="2iw3i6txj1ccv" /> Color
                </span>
                <span className="font-medium text-[#F2F0E9]" data-id="element-361" data-mp="35h07e2ngqh2">
                  {vehicle.color}
                </span>
              </div>
            </div>

            {/* CTAs */}
            <div className="space-y-3" data-id="element-362" data-mp="3uduzghiyuqo7">
              <button onClick={handleWhatsApp} className="w-full py-4 px-6 rounded-xl bg-[#25D366] hover:bg-[#128C7E] text-white font-bold text-lg flex items-center justify-center gap-2 transition-colors shadow-md" data-id="element-363" data-mp="2gzkcy11bbart">
                <MessageCircle className="w-6 h-6" data-id="element-364" data-mp="2774vd4txgo7g" />
                Consultar por WhatsApp
              </button>
            </div>

            {/* Trust Badges */}
            <div className="mt-6 p-4 rounded-xl bg-[#343830] flex items-start gap-3" data-id="element-365" data-mp="1yae373ihxti5">
              <CheckCircle2 className="w-6 h-6 text-[#C9A24E] flex-shrink-0" data-id="element-366" data-mp="1t8ygl70o7exn" />
              <div data-id="element-367" data-mp="1o9v9zi51l0nk">
                <h4 className="font-semibold text-[#F2F0E9] text-sm" data-id="element-368" data-mp="1obeq98qp7bpc">
                  Garantía Lusso Group
                </h4>
                <p className="text-xs text-[#A8AA9E] mt-1" data-id="element-369" data-mp="1kb4ne4y7d1ep">
                  Vehículo inspeccionado en 150 puntos. Documentación al día,
                  listo para transferir.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}